"use strict";

module.exports = [];


// WEBPACK FOOTER //
// ../node_modules/@sanity/client/lib/http/browserMiddleware.js